import { TeamOutlined } from '@ant-design/icons';
import { type IDelegationData } from '@framework/frontoffice-submission/module/delegation/DelegationLogic.ts';
import { Popover, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { DelegationInfoTooltipLabel } from './DelegationInfoTooltipLabel.tsx';

interface IDelegationInfoTooltipProps {
  delegationData: IDelegationData;
}

/**
 * Piccolo componente che mostra le attuali informazioni relative agli
 * utenti interessati alla richiesta (titolare e procuratore)
 */
export function DelegationInfoTooltip(props: IDelegationInfoTooltipProps) {
  const { delegationData } = props;

  const attorney = delegationData?.attorney;
  const applicant = delegationData?.applicant?.find(a => a.isMain);

  const { t } = useTranslation();

  return (
    <Popover
      title={
        <Typography.Title level={5}>
          {t(
            'submission.info.titolare-e-procuratore',
            'Titolare e procuratore',
          )}
        </Typography.Title>
      }
      aria-label={t(
        'submission.info.aria.titolare-e-procuratore',
        'Titolare e procuratore',
      )}
      content={
        <Space direction="vertical" size={1}>
          {applicant && (
            <DelegationInfoTooltipLabel
              label={t('submission.titolare', 'Titolare')}
              name={applicant.name}
              fiscalCode={applicant.fiscalCode}
            />
          )}
          {attorney && (
            <DelegationInfoTooltipLabel
              label={t('submission.procuratore', 'Procuratore')}
              name={attorney.name}
              fiscalCode={attorney.fiscalCode}
            />
          )}
        </Space>
      }
    >
      <TeamOutlined />
    </Popover>
  );
}
